module.exports = __webpack_public_path__ + "img/walking.f8bb8052.svg";